class FixedHeader {
	body: HTMLElement | null;
	utilityNav: HTMLElement | null;

	constructor() {
		this.body = document.querySelector('body');
		this.utilityNav = document.querySelector('.utility-nav-wrapper');
		this.toggleFixedHeader = this.toggleFixedHeader.bind(this);
	}

	init() {
		$(document).on('scroll', this.toggleFixedHeader);
	}

	toggleFixedHeader() {
		if (this.body) {
			if (window.scrollY > 20) {
				if (this.utilityNav) {
					$(this.utilityNav).slideUp('400');
				}
				this.body.classList.add('fixed-header');
			} else if (window.scrollY === 0) {
				if (this.utilityNav) {
					$(this.utilityNav).slideDown();
				}
				this.body.classList.remove('fixed-header');
			}
		}
	}
}

export default new FixedHeader();
